import { IAnnouncement } from '@/utils/index.model';
import { API_URLS } from '@/utils/constant';
import { getData, keysToCamel } from '@/utils/helpers';

interface IAnnouncementState {
  announcements: IAnnouncement[];
}

const ANNOUNCEMENT_DATA: IAnnouncement = {
  message: '',
  publishDateTime: '',
};

export const state = () => ({ announcements: [] });

export const mutations = {
  UPDATE_ANNOUNCEMENT(stateData: IAnnouncementState, announcements: IAnnouncement[]): void {
    stateData.announcements = [...announcements];
  },
  RESET_ANNOUNCEMENT(stateData: IAnnouncementState) {
    stateData.announcements = [] as IAnnouncement[];
  },
};

export const actions = {
  updateAnnouncement(context: any): void {
    const { rootGetters } = context;
    const { language } = rootGetters['general/config'];
    const token = rootGetters['general/token'];
    const params = {
      page: 1,
      page_size: 32,
      lang: language,
    };
    getData(API_URLS.ANNOUNCEMENTS, token, params)
      .then((res: any) => {
        context.commit('UPDATE_ANNOUNCEMENT', keysToCamel(res));
      })
      .catch((e: any) => console.log(e));
  },
  resetAnnouncement(context: any): void {
    context.commit('RESET_ANNOUNCEMENT');
  },
};

export const getters = {
  announcements: (stateData: any): IAnnouncement[] => {
    return stateData.announcements;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
